<template>
  <div vclass="upload_list">
    <div v-if="data.id">
      <p :class="`upload_list_title${
          data.required ? ' upload_list_title_required' : ''
        }`">
        {{ data[`name${$t('message.lan')}`] }}
      </p>
      <div v-if="$route.meta.search"
          class="upload_reson">{{$t('message.supplementReason')}}{{follow.supplementReason}}</div>
      <div class="upload_list_tips">
        {{ data[`description${$t("message.lan")}`] }}
        <br />
        {{ $t("message.support_files_part1") }}{{ data.fileExtensions
        }}{{ $t("message.support_files_part2") }}{{ data.maxFileSize }}MB.
      </div>
      <div class="upload_type2"
          v-if="data.uploadType == 2">
      </div>
    </div>
    <div v-else>
      <p :class="`upload_list_title${
          data.reverseSide.required ? ' upload_list_title_required' : ''
        }`">
        {{ data.reverseSide[`name${$t('message.lan')}`] }}
      </p>
      <div v-if="$route.meta.search"
          class="upload_reson">{{$t('message.supplementReason')}}{{follow.supplementReason}}</div>
      <div class="upload_list_tips">
        {{ data.reverseSide[`description${$t("message.lan")}`] }}
        <br />
        {{ $t("message.support_files_part1") }}{{ data.reverseSide.fileExtensions
        }}{{ $t("message.support_files_part2") }}{{ data.reverseSide.maxFileSize }}MB.
      </div>
      <div class="upload_type2"
          v-if="data.reverseSide.uploadType == 2">
      </div>
    </div>
    <Splicing :isPreview="false"
              :data="data"
              @getRes="getSpellData">
    </Splicing>
  </div>
</template>

<script>
import { resourcePath } from "../../../../api/axios";
import Splicing from "../../../../components/Splicing"
export default {
  components: { Splicing },
  props: [
    "data",
    "follow"
  ],
  data () {
    return {
      resourcePath: resourcePath,
      fileList: [],
      fileList2: [],
      fileUrl: "",
      imageUrl: "",
      imageUrl2: "",
      uploadType: "upload",
      studioCode: null,
      dialogImgUrl: ""
    };
  },
  computed: {
  },
  methods: {
    getSpellData (e) {
      console.log(e);
      this.$emit("change", e);
    }
  },
  created () {
    if (this.data.file) {
      this.fileList = [this.data.file];
    }
  },
};
</script>

<style lang="scss" scoped>
.upload_list {
  border-bottom: 1px solid rgba(50, 50, 50, 0.16);
}
.upload_list_title {
  font-size: 18px;
  line-height: 25px;
  margin: 15px 0;
  color: #1c1c1c;
  font-weight: bold;
}
.upload_list_title_required:after {
  content: '*';
  color: #f56c6c;
  margin-left: 4px;
}
.upload_list_tips {
  background: rgba(162, 214, 255, 0.13);
  border-radius: 4px;
  padding: 12px 14px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(144, 144, 144, 1);
  line-height: 22px;
}
.upload_list_file {
  padding: 16px 0;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  background: #f2f2f2;
  padding: 10px;
  border-radius: 10px;
  max-width: 450px;
  margin: 20px 0;
  .avatar-uploader {
    margin-right: 24px;
    background: #fff;
    border-radius: 10px;
  }
  /deep/.el-upload {
    width: 200px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 280px;
  }
}
.select_uoload_type {
  line-height: 35px;
  font-size: 18px;
}
.upload_del {
  color: #f40101;
  margin-left: 5px;
  cursor: pointer;
}
.upload_filename {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
.avatar-uploader img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  margin: auto;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  background: #fff;
  border-radius: 10px;
  margin-right: 24px;
}
.avatar {
  width: 178px;
  display: block;
  border-radius: 10px;
  // margin-right: 24px;
}
/deep/.upload_disabled {
  .el-upload {
    cursor: not-allowed;
    opacity: 0.8;
  }
}
.upload_input {
  max-width: 450px;
  width: 100%;
  margin-bottom: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  /deep/.el-input {
    flex: 1;
  }
  .pub_btn {
    margin-top: 0;
  }
  .pub_btn .el-button {
    min-width: 100px;
  }
}
.upload_type2 {
  margin-bottom: 24px;
}
.upload_type2_top {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 14px 0;
  .pub_btn {
    margin-top: 0;
  }
}

.upload_type2_file {
  border-radius: 10px;
  border: 1px solid #d7d7d7;
  text-align: center;
  overflow: hidden;
  .avatar-uploader {
    height: 170px;
  }
  /deep/.el-upload,
  .avatar-uploader-icon {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    // justify-content: center;
    flex-wrap: wrap;
  }
  .avatar {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 170px;
    margin: auto;
  }
}
.upload_reson {
  font-size: 16px;
  font-weight: 400;
  color: rgba(250, 29, 29, 1);
  line-height: 22px;
  margin-bottom: 20px;
}
@media screen and (max-width: 767px) {
  .upload_list_file {
    flex-direction: column;
    align-items: flex-start;
    .pub_btn {
      margin-left: auto;
      margin-right: auto;
    }
  }
}
</style>